export const SEARCH_ICON = '/assets/dashboardImg/Search.png';
export const ARROW_PATH_ICON = '/assets/dashboardImg/Path.png';
export const STATIC_LINK_PATH = '/dashboard/trending-stocks/stocks-details/';
